<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :key_type="filters.type"
      :key_status="filters.status"
      :type_arr="typeArr"
      @changeStatus="changeLeftSideStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :key_type="filters.type"
        :key_status="filters.status"
        :type_arr="typeArr"
        @clearKey="clearKey"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        :type_arr="typeArr"
      ></router-view>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/download/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
import { pagination } from "@components/pagination.js"; //分页
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头

export default {
  components: {
    LeftSide,
    Header,
    pagination,
  },
  data() {
    return {
      firstLoading: false,
      loading: true,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50, 100, 200, 500],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("stockout-filter-rowsPerPage"))
        ? parseInt(store.get("stockout-filter-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      filters: {
        type: "",
        status: "",
      },
      typeArr: "",
    };
  },
  mounted() {
    this.getList();
    this.getType();
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("download-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    getType() {
      $.api_call("api.UserTask.getTypes", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.typeArr = r.Data.Results;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getList() {
      this.loading = true;
      this.firstLoading = true;
      let vm = this;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        status: this.filters.status,
        type: this.filters.type,
      };
      let getData = (data) => {
        this.items = data.Results ? data.Results : [];
        this.totalPage = data.Pagination.totalPage;
        this.totalCount = data.Pagination.totalCount;
        $("html,body").scrollTop(0);
      };
      $.api_call("api.UserTask.findByUser", params, function (r) {
        vm.loading = false;
        vm.firstLoading = false;
        if (r.ErrorCode == "9999") {
          getData(r.Data);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    filtrate(type, status) {
      this.filters.status = status;
      this.filters.type = type;
      //筛选都回第一页
      this.toPage(1);
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/download/" + 1 });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/download/" + num });
      if (page == num) {
        this.getList();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    clearKey(type) {
      switch (type) {
        case "status":
          this.filters.status = "";
          break;
        case "type":
          this.filters.type = "";
          break;
      }
      this.toPage(1);
    },
  },
};
</script>
